import React, { Component } from 'react';
import { Table, Tag, Modal, Input, Button, Icon,Row,Col,Select,Switch,message  } from 'antd';
import { withApollo } from 'react-apollo';
import moment from 'moment';
import Highlighter from 'react-highlight-words';
import {Link} from 'react-router-dom';
import App from '../../App';
import getInternalUsersByUserRole from '../../queries/getInternalUsersByUserRole';
import CPrecharge from './cpRecharge';
import {returnSymbol} from '../../utils/returnSymbol'
import { country } from '../../utils/countryCurrency';
import updateInternalUser from '../../mutation/updateInternalUser'

const Option = Select.Option
class CPList extends Component {
  state = {
    loading: false,
    isWalletOpen: false,
    serviceMapModal: false,
    selectedCPData: null,
    cpData: [],
    allcpData: [],
    searchText: '',
    selectedCountry: undefined,
    statusLoading: false,
    loadId: undefined

  };

  componentDidMount() {
    this.getUsers();
  }

  getUsers = () => {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getInternalUsersByUserRole,
        variables: { userRole: 'CP' },
        fetchPolicy: 'no-cache',
      })
      .then(({ data }) => {
        let filterData = data.getInternalUsersByUserRole;
        filterData.sort((a, b) => (a.companyName < b.companyName ? -1 : 1));
        let newArr = filterData.map((ele, i) => ({ ...ele, srNo: i + 1, companyName: ele.companyName || '',country:ele.address && ele.address.country ? ele.address.country: '',state:ele.address && ele.address.state ? ele.address.state: '',city:ele.address && ele.address.city ? ele.address.city : '' }));
        newArr = this.createData(newArr);
        // console.log("newArr :::", newArr);
        this.setState({ cpData: newArr,allcpData:newArr, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

  createData = (data) => {
    console.log("data :::", data);
    let iterator, balance = 0;
    for (let i = 0; i < data.length; i++) {
      iterator = data[i];
      balance += iterator.balance ? iterator.balance : 0;
    }
    data.unshift({
      onboardedBy: "Total Balance",
      balance,
    });
    return data;
  }

  openWalletModal = (record) => {
    this.setState({ selectedCPData: record, isWalletOpen: true });
  };

  handleCancel = (rechargeData) => {
    let cpData  = this.state.cpData
    if(rechargeData && rechargeData.amount){
      let index = cpData.findIndex((x)=>x.username == rechargeData.userId)
      if(rechargeData && rechargeData.transactionType == 'CREDIT'){
        cpData[index].balance = parseFloat(cpData[index].balance) + parseFloat(rechargeData.amount)
      }else{
        cpData[index].balance = parseFloat(cpData[index].balance) - parseFloat(rechargeData.amount)
      }
    }

    // cpData = this.createData([...cpData]);

    this.setState({ cpData: cpData,isWalletOpen: false, selectedCPData: null });
    // this.getUsers()
  };
  onCountryChange=async(value)=>{
        // let index = country.findIndex((x)=>x.value == value)
    //  let response = await getStateByCountry(country[index].key)
    //  console.log("response ::",response)
     this.setState({
      selectedCountry: value,
      // allState:response
     })
  
  }

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ""}
      />
    ),
  })
  handleFilter=()=>{
    let selectedCountry = this.state.selectedCountry
    let allcpData = this.state.allcpData
    let filterData = this.state.allcpData
    if(this.state.selectedCountry != undefined){
      let aar =  allcpData.filter((x)=>x.country == this.state.selectedCountry).filter((x) => !x.id)
      filterData = aar 
     }
     let newArr = filterData.map((ele, i) => ({ ...ele, srNo: i + 1 }));
     newArr = this.createData(newArr);
     this.setState({
      cpData:newArr
     })

  }
  resetFilter=()=>{
    let newArr = this.createData([...this.state.allcpData]);
    this.setState({
      cpData: newArr,
      selectedCountry: undefined
     })
  }
  onChangeStatus=(record)=>{
    console.log("record",record)
    this.setState({
      statusLoading: true,
      loadId: record.username
    })
    this.props.client.mutate({
      mutation: updateInternalUser,
      variables: {
          siteId: record.siteId,
          username: record.username,
          emailId: record.emailId,
          mobile: record.mobile,
          enabled: !record.enabled
      }
  }).then(({ data }) => {
    if(data.updateInternalUser){
      console.log("Resp SiteConfig ::", data)
      message.success('CP Status Updated Successfully')
      let cpData = this.state.cpData
      let index = cpData.findIndex((x)=>x.username == record.username)
      cpData[index].enabled = data.updateInternalUser.enabled
      cpData = this.createData([...cpData]);
      this.setState({
        statusLoading: false,
        loadId: undefined,
        cpData: cpData
      })
    }else{
      this.setState({
        statusLoading: false,
        loadId: undefined,
      })
    }
  })
  }
  render() {
    const { loading, isWalletOpen, serviceMapModal, selectedCPData, cpData } = this.state;
    // console.log("cpData",cpData)
    const columns = [
      { title: 'Sr', dataIndex: 'srNo', width: 30 },
      { title: 'Company Name', dataIndex: 'companyName', width: 150, ...this.getColumnSearchProps('companyName') },
      { title: 'Contact Person', dataIndex: 'name', width: 120, ...this.getColumnSearchProps('name') },
      { title: 'Mobile', dataIndex: 'mobile', width: 120, ...this.getColumnSearchProps('mobile') },
      { title: 'Sales Person', dataIndex: 'onboardedBy', width: 100, ...this.getColumnSearchProps('onboardedBy') },
      { 
        title: 'Wallet Balance',
        // dataIndex: 'balance',
        width: 90,
        align: "right",
        sorter: (a, b) => a.balance - b.balance,
        render: (data) => {
          return (
            <span style={{ fontWeight: "bold" }} className={data.id ? "" : "f-size-14"}>
              {returnSymbol(parseFloat(data.balance/100),data.currency && data.currency ? data.currency : 'INR' )}
            </span>
          );
          // return(
          //   <span>{returnSymbol(parseFloat(data.balance/100),data.currency && data.currency ? data.currency : 'INR' )}</span>
          // )
        }
      },
      {
        title: 'Country',
        width: 80,
        dataIndex: 'address', // Ensure dataIndex is set correctly
        render: (address) => {
          if(address && address.country){
            let country1 = country.find((code)=>code.value == address.country)
            return(
              <span>{address && address.country ? country1.label : ''}</span>
            )
          } else {
            return "";
          }
        }
      },
      {
        title: 'City',
        width: 80,
        dataIndex: 'city',
        // render: (address) => <span>{address && address.city ? address.city : ''}</span>,
         ...this.getColumnSearchProps('city')
      },
      {
        title: 'CP Since',
        width: 80,
        dataIndex: 'createdAt',
        render: (createdAt) => <span>{createdAt ? moment.unix(createdAt).format("DD/MM/YYYY") : ""}</span>,
      },
      {
        title: 'Status',
        width: 60,
        render: (record) =>{
          let isLoading = this.state.loadId == record.username ? this.state.loadId : false
          return(
            record.enabled ? <Switch checked={record.enabled} loading={isLoading} disabled={isLoading} onChange={()=>this.onChangeStatus(record)} /> : ""
          )
        }
           
      },
      { title: 'Total Customers', width: 100, dataIndex: 'totalCust' },
      { title: 'Last Customer', width: 100, dataIndex: 'lastCustomer' },
      {
        title: 'Actions',
        fixed: 'right',
        width: 160,
        render: (data) => {
          if(!data.id) return ""
          return <span>
            <Tag color="green" style={{ cursor: 'pointer', marginRight: '5px' }} onClick={() => this.openWalletModal(data)}>
              Wallet
            </Tag>
            <Link to={{ pathname: "/serviceMap", state: { cpData: data } }}>
            <Tag color="lime" style={{ cursor: 'pointer', marginRight: '5px' }}>
              Services
            </Tag>
            </Link>
            {/* <Tag color="blue" style={{ cursor: 'pointer', marginRight: '5px' }}>{data.enabled ? 'Active' : 'Inactive'}</Tag> */}
            {/* <Tag color="magenta" style={{ cursor: 'pointer', marginRight: '5px' }}>Profile</Tag> */}
          </span>
        },
      },
    ];

    return (
      <App header={'CP List'}>
        <Row gutter={24} style={{ marginTop: '15px' }}>
          <Col md={{ span: 5 }}>
            <Select
              optionFilterProp="children"
              style={{ width: '100%', marginRight: '10px' }}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              placeholder="Country"
              value={this.state.selectedCountry}
              allowClear
              showSearch
              onChange={this.onCountryChange}>
              {country.map((c) => {
                return (
                  <Option key={c.value} value={c.value} >{c.label}</Option>
                )
              })}
            </Select>
          </Col>
          <Col md={{ span: 4 }}>
            <Button type='danger' style={{ float: "right", marginBottom: 16, cursor: "pointer", marginLeft: '10px', width: 60 }} onClick={this.resetFilter}>Reset</Button>
            <Button type='primary' style={{ float: "right", marginBottom: 16, cursor: "pointer", width: 70 }} loading={this.state.filterLoadimg} onClick={this.handleFilter}>Search</Button>
          </Col>
        </Row>
        <Table className='sitetable' size="middle" columns={columns} dataSource={cpData} loading={loading} scroll={{ x: '110%' }} pagination={{ pageSize: 100 }}/>
        <Modal title="Recharge" visible={isWalletOpen} footer={null} onCancel={this.handleCancel} width={800} destroyOnClose>
          <CPrecharge cpData={selectedCPData} handleCancel={this.handleCancel} />
        </Modal>
      </App>
    );
  }
}

export default withApollo(CPList);